import React, { Component, useCallback, useEffect, useRef, useState } from 'react';
import "./css/WarningBox.css";
import $ from 'jquery';

export function WarningBox({ shown, message, description, close }) {

    useEffect(() => {
        if (shown) {
            showWarningBox();
        }
    }, [shown])

    function showWarningBox() {
        $('#warning-box-container').fadeIn(300);
        $('#warning-box-container').css('display', 'flex');
    }

    function dismiss(yes) {
        $('#warning-box-container').fadeOut(300);
        close(yes);
    }


    return (
        <div className="warning-box-container" id="warning-box-container" onClick={() => { dismiss(false) }}>
            <div className="warning-box" id="warning-box" onClick={(e) => { e.stopPropagation() }}>
                <div className="content">
                    <img className="danger-icon" src="icons/danger.svg" />
                    <div className="text-box">
                        <div className="message" id="message">
                            {message}
                        </div>
                        <br />
                        <div className="description" id="description">
                            {description}
                        </div>
                    </div>
                </div>
                <div className="bottom-bar">
                    <div className="yes-button" id="yes-button"
                        onClick={() => { dismiss(true) }}>
                        Yes
                    </div>
                    <div className="no-button" id="no-button" onClick={() => { dismiss(false) }}>
                        No
                    </div>
                </div>
            </div>
        </div>
    );
}
